import { Disclosure } from "@headlessui/react";
import { ChevronRightIcon } from "@xola/icons";
import { SlideDown } from "@xola/ui-kit";
import clsx from "clsx";
import React, { Children, ReactNode } from "react";

interface AccordionProps {
    children: ReactNode;
    defaultOpen?: boolean;
}

export const Accordion = ({ children, defaultOpen = false }: AccordionProps) => {
    const childrenArray = Children.toArray(children);
    return (
        <div>
            <Disclosure defaultOpen={defaultOpen}>
                {({ open }) => (
                    <>
                        <Disclosure.Button className="flex items-center">
                            <div className="mr-2" data-testid="accordion-dropdown-icon">
                                <ChevronRightIcon className={clsx(open && "rotate-90")} />
                            </div>

                            {childrenArray.filter((child) => (child as any)?.type === Header)}
                        </Disclosure.Button>

                        <SlideDown isOpen={open}>
                            {childrenArray.filter((child) => (child as any)?.type === Body)}
                        </SlideDown>
                    </>
                )}
            </Disclosure>
        </div>
    );
};

interface HeaderProps {
    className?: string;
    children: ReactNode;
}

const Header = ({ className, children, ...rest }: HeaderProps) => {
    return (
        <div className={clsx("flex items-center space-x-3", className)} {...rest}>
            {children}
        </div>
    );
};

Accordion.Header = Header;

const Body = ({ className, children, ...rest }: HeaderProps) => {
    return (
        <Disclosure.Panel as="div" className={clsx("p-2 pb-10", className)} {...rest}>
            {children}
        </Disclosure.Panel>
    );
};

Accordion.Body = Body;
